/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

exports.getBuyerRetailerShopListBySvcNo = function (postData, callback) {// 查询服务号相关买家门店信息
    api.post('/retailer/svc/no/buyer/shop/list')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.getRetailerList = function (data, callback) {// 获取零售商列表
    api.post('/retailer/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerOrgComList = function (data, callback) {// 获取零售商公司信息
    api.post('/retailer/org/com/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailer = function (data, callback) {// 获取零售商
    api.post('/retailer/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerShopList = function (data, callback) {// 获取零售商门店分页列表
    api.post('/retailer/shop/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerComPagedListForRent = function (data, callback) {// 获取租赁业务相关的零售机构分页列表
    api.post('/retailer/com/paged/list/get/for/rent')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateRetailerComRentDefRepairStaff = function (data, callback) {// 设置租赁默认提报人
    api.post('/retailer/com/rentDefRepairStaff/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerCom = function (data, callback) {// 零售商詳情
    api.post('/retailer/com/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerComForSync = function (data, callback) {// 零售商詳情
    api.post('/retailer/com/get')
    .sync(true)
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerComList = function (data, callback) {// 获取服务商下已关联的零售机构列表（包括设备关联的和常规服务关联的）
    api.post('/retailer/com/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取公司列表
exports.getRetailerComBizUnitList = function (params, callback) {// 获取零售商公司列表
    api.post('/retailer/biz/unit/com/list/get')
        .data(params)
        .done(callback)
        .go();
};

exports.getRetailerShopTagList = function (data, callback) {// 查询零售商门店（用）标签列表
    api.post('/retailer/shop/tag/get/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getRetailerAddrList = function (data, callback) {// 获取零售商门店信息
    api.post('/retailer/addr/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantDtoPageList = function (data, callback) {// 获取零售商列表
    api.post('/retailer/merchant/dto/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchantDtoListByIds = function (data, callback) {// 获取零售商列表
    api.post('/retailer/merchant/dto/list/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchantDto = function (data, callback) {// 获取零售商
    api.post('/retailer/merchant/dto/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取业务标签列表
exports.getBizTagList = function (data, callback) {
    api.post('/retailer/biz/tags/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取零售商列表
exports.getRetailerListByFilter = function (data, callback) {
    api.post('/retailer/list/get/by/filter')
    .data(data)
    .done(callback)
    .go();
};
// 获取零售商列表
exports.getPlatformRetailerList = function (data, callback) {
    api.post('/retailer/platform/retailer/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取已经关联平台商户（零售商）列表
exports.getPlatformRetailerListByFilter = function (data, callback) {
    api.post('/retailer/platform/list/get/by/filter')
    .data(data)
    .done(callback)
    .go();
};
// 保存已经关联平台商户（零售商）
exports.getPlatformRetailerSave = function (data, callback) {
    api.post('/retailer/platform/save/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/retailer.js
// module id = 20
// module chunks = 1